<template>
      <version ></version>

</template>

<script>
    import Version from '@/components/page/fota/Version'
    export default {
        name: 'versionHomeAdd',
        components: {Version} 
    }   
</script>

<style></style>